/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * Číselník orientací obrazovky.
 * @enum {'CLOCKWISE_0' | 'CLOCKWISE_90' | 'CLOCKWISE_180' | 'CLOCKWISE_270' | 'UNKNOWN'}
 * @readonly
 */
const OrientationEnum = /** @type {const} */ ({
  CLOCKWISE_0: 'CLOCKWISE_0',
  CLOCKWISE_90: 'CLOCKWISE_90',
  CLOCKWISE_180: 'CLOCKWISE_180',
  CLOCKWISE_270: 'CLOCKWISE_270',
  UNKNOWN: 'UNKNOWN'
});

/**
 * @param {Omit<OrientationEnum, 'UNKNOWN'>} orientation
 * @returns {boolean}
 */
export function isHorizontal(orientation) {
  return (
    orientation === OrientationEnum.CLOCKWISE_0 ||
    orientation === OrientationEnum.CLOCKWISE_180
  );
}

export default OrientationEnum;
